import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import gmailIcon from "@/assets/gmail.svg";
import teamsIcon from "@/assets/teams.svg";
import instaIcon from "@/assets/instagram.svg";
import slackIcon from "@/assets/slack.svg";
import messengerIcon from "@/assets/messenger.svg";

import outlookIcon from "@/assets/outlook.svg";

const workflowLogos = [
  { name: "Gmail", icon: gmailIcon },
  { name: "Outlook", icon: outlookIcon },
  { name: "Teams", icon: teamsIcon },
  { name: "Slack", icon: slackIcon },
  { name: "Instagram", icon: instaIcon },
  { name: "Messenger", icon: messengerIcon },
];

export const WorkflowIntegrationsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="integrations" className="py-16 relative overflow-hidden">
      <div className="absolute inset-0 bg-[#0A0F1C]" />
      <div className="absolute inset-0 noise-texture opacity-20" />
      <div className="container relative z-10" ref={ref}>
        <motion.p
          className="text-center text-xs md:text-sm font-medium uppercase tracking-widest text-gray-500 mb-12"
          initial={{ opacity: 0, y: 10 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          Seamlessly integrated with your workflow
        </motion.p>

        {/* Single row of icons - no animation, no repeat, full color */}
        <motion.div
          className="flex flex-wrap items-center justify-center gap-8 md:gap-12"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5 }}
        >
          {workflowLogos.map((item) => (
            <div
              key={item.name}
              className="flex-shrink-0 flex flex-col items-center gap-2"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center p-2.5">
                <img
                  src={item.icon}
                  alt={item.name}
                  className="w-8 h-8 md:w-10 md:h-10 object-contain opacity-90"
                />
              </div>
              <span className="text-[10px] md:text-xs text-gray-500 text-center">
                {item.name}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
